













import { Component, Prop, Vue } from "vue-property-decorator";
import { IAccount } from "@/interfaces";

@Component
export default class WalletVote extends Vue {
  @Prop({ required: true }) public wallet: IAccount;

  private view = "public";
  private knownAccounts: { [key: string]: string };

  get votedDelegate() {
    return this.$store.getters["delegates/byPublicKey"](this.wallet.vote) || {};
  }

  get isVoting() {
    return !!this.wallet.vote;
  }
}
